import React, { useState, useEffect } from "react"
import { Card, CardBody, Col, Row, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { SlButton, SelectInput, SLImageSelectable } from '../editors';
import { metadataService, LoanInfoApi } from "../../_services";
import PropTypes from 'prop-types';

export const SelectPaymentMethod = (props) => {
    const TYPE_ACH = 'ach';
    const TYPE_CARD = 'card';

    const [selectedPaymentType, setSelectedPaymentType] = useState(props.enableAchPayments ? TYPE_ACH : TYPE_CARD);
    const [savedPaymentMethod, setSavedPaymentMethod] = useState("");
    const [deleteCardIsOpen, setDeleteCardIsOpen] = useState(false);
    const [cardVault, setCardVault] = useState([]);

    useEffect(() => {
        (async () => {
            var vault = await LoanInfoApi.getSavedPayments(props.processor);
            setCardVault(vault || []);
        })();
    }, [props.processor, props.accountId])

    useEffect(() => {
        props.onPaymentMethodChange({
            paymentType: selectedPaymentType,
            savedPaymentId: savedPaymentMethod
        });
    }, [selectedPaymentType, savedPaymentMethod]);

    const handlePaymentTypeChanged = (event) => {
        setSelectedPaymentType(event.target.value);
    }

    const getSavedPaymentLabel = (payment) => {
        if (payment.storedPaymentType === "card_token") {
            return payment.cardDescription + " (" + payment.cardLastFour + ") " + payment.cardExpiration.substring(0, 2) + "/" + payment.cardExpiration.substring(2);
        } else {
            return payment.accountType + " - " + payment.nameOnCheck + " (" + payment.accountLastFour + ")";
        }
    }
    const handleChangeCard = (e) => {
        setSavedPaymentMethod(e.target.value);
    }

    const handleDeleteCard = (_) => {
        LoanInfoApi.deleteSavedPayments(savedPaymentMethod).then(e => {
            if (e.status < 2) {
                setCardVault(e.data);
                setSavedPaymentMethod("");
                setDeleteCardIsOpen(false);
            }
        });
    }

    const savedCards = cardVault.filter(d => d.storedPaymentType === "card_token");
    const savedBanks = cardVault.filter(d => d.storedPaymentType === "ach_token");
    const closeBtn = <button className="close" onClick={() => setDeleteCardIsOpen(false)}>&times;</button>;;

    return (
        <Card>
            <CardBody>
                {props.enableAchPayments &&
                    <Row className="mb-4 justify-content-center">
                        <Col xs={12} sm={6} md={4} lg={4}>
                            <SLImageSelectable
                                selected={selectedPaymentType === TYPE_ACH}
                                title={<i class="fa fa-3x fa-bank"></i>}
                                name="paymentOption"
                                value={TYPE_ACH}
                                onChange={handlePaymentTypeChanged}
                            />
                        </Col>
                        <Col>
                            <h4>{metadataService.getMessage("PayByBankHeader")}</h4>
                            <p>{metadataService.getMessage("PayByBank")}</p>
                            <SelectInput
                                name="SelectBank"
                                showLabel={false}
                                onChange={handleChangeCard}
                                disabled={selectedPaymentType !== TYPE_ACH}
                                isRequired={false}
                                placeholder={metadataService.getLabel("NewBank")}
                                options={
                                    savedBanks.map(e => {
                                        return {
                                            text:
                                                getSavedPaymentLabel(e),
                                            value: e.storedPmtId
                                        };
                                    })}
                                value={savedPaymentMethod}
                            />

                            {selectedPaymentType === TYPE_ACH && savedPaymentMethod !== "" &&
                                <a onClick={() => setDeleteCardIsOpen(true)}>
                                    {metadataService.getButton("RemoveSavedBank")}
                                </a>
                            }
                        </Col>
                    </Row>
                }

                <Row className="justify-content-center">
                    <Col xs={12} sm={6} md={4} lg={4}>
                        <SLImageSelectable
                            selected={selectedPaymentType === TYPE_CARD}
                            title={<i class="fa fa-3x fa-credit-card-alt"></i>}
                            name="paymentOption"
                            value={TYPE_CARD}
                            onChange={handlePaymentTypeChanged}
                        />
                    </Col>
                    <Col>
                        <h4>{metadataService.getMessage("PayByCardHeader")}</h4>
                        {props.convenienceFees ?
                            <p>{metadataService.getMessage("PayByCard", props.convenienceFees)}</p>
                            :
                            <p>{metadataService.getMessage("PayByCardNoFee")}</p>
                        }
                        <SelectInput
                            name="SelectCard"
                            showLabel={false}
                            onChange={handleChangeCard}
                            disabled={selectedPaymentType !== TYPE_CARD}
                            isRequired={false}
                            placeholder={metadataService.getLabel("NewDebitCard")}
                            options={
                                savedCards.map(e => {
                                    return {
                                        text:
                                            getSavedPaymentLabel(e),
                                        value: e.storedPmtId
                                    };
                                })}
                            value={savedPaymentMethod}
                        />

                        {selectedPaymentType === TYPE_CARD && savedPaymentMethod !== "" &&
                            <a onClick={() => setDeleteCardIsOpen(true)}>
                                {metadataService.getButton("RemoveSavedCard")}
                            </a>
                        }
                    </Col>
                </Row>

                <Modal isOpen={deleteCardIsOpen} toggle={setDeleteCardIsOpen}>
                    <ModalHeader close={closeBtn}>
                        {metadataService.getButton("RemoveSavedPaymentMethod")}
                    </ModalHeader>
                    <ModalBody>
                        {metadataService.getMessage("ConfirmRemoveSavedPaymentMethod", getSavedPaymentLabel(savedPaymentMethod))}
                    </ModalBody>
                    <ModalFooter>
                        <SlButton onClick={handleDeleteCard} name="Remove" disabled={savedPaymentMethod === ""} />
                        <SlButton onClick={() => setDeleteCardIsOpen(false)} name="Cancel" />
                    </ModalFooter>
                </Modal>
            </CardBody>
        </Card>
    )
}

SelectPaymentMethod.propTypes = {
    enableAchPayments: PropTypes.bool.isRequired,
    processor: PropTypes.string.isRequired,
    accountId: PropTypes.number.isRequired
}


// WEBPACK FOOTER //
// ./src/components/subcomponents/SelectPaymentMethod.jsx